var _title, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLoading = function SvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "ICON/loading_18dp")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u6807",
    transform: "translate(-1933.000000, -170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICON/loading_18dp",
    transform: "translate(1933.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,4 C16.0146038,4 19.3385317,6.95713521 19.9123985,10.8120205 L17.9343481,11.109346 C17.5040888,8.21802047 15.0110676,6 12,6 C8.6862915,6 6,8.6862915 6,12 C6,15.3137085 8.6862915,18 12,18 L12,20 L12,20 C7.581722,20 4,16.418278 4,12 C4,7.581722 7.581722,4 12,4 Z M15.8568174,16.596371 L17.1429362,18.1280637 C16.3837571,18.7658675 15.5043492,19.2651942 14.5436078,19.5871483 L13.9073633,17.690476 C14.6278905,17.4490687 15.2874304,17.0746451 15.8568174,16.596371 Z M17.9098952,13.0416923 L19.8797086,13.3897893 C19.7034338,14.3961338 19.339081,15.3377635 18.8242196,16.1771088 L17.1181067,15.1329262 C17.5043942,14.5032127 17.7777256,13.7967328 17.9098952,13.0416923 Z",
    id: "\\u5F62\\u72B6",
    fill: "#F1F902",
    fillRule: "nonzero"
  }))))));
};

export { SvgLoading as ReactComponent };
export default __webpack_public_path__ + "6a5b892d7945a2a6e138849b0f3750a6.svg";